import { Upload, User, Home, Car, Shield } from 'lucide-react';

export const STEPS = [
  { id: 1, label: 'Declarations', icon: Upload },
  { id: 2, label: 'Personal Info', icon: User },
  { id: 3, label: 'Properties', icon: Home },
  { id: 4, label: 'Vehicles', icon: Car },
  { id: 5, label: 'Vehicle Details', icon: Car },
  { id: 6, label: 'Liability', icon: Shield },
];

export const PROPERTY_TYPES = ['Primary Home', 'Secondary Home', 'Rental Property'];
export const ROOF_MATERIALS = ['Asphalt Shingle', 'Metal', 'Tile', 'Slate', 'Wood Shake', 'Flat/Rubber', 'Other'];
export const ROOF_SHAPES = ['Gable', 'Hip', 'Flat', 'Gambrel', 'Mansard', 'Other'];
export const CONSTRUCTION_TYPES = ['Frame', 'Masonry', 'Masonry Veneer', 'Other'];
export const OWNERSHIP_TYPES = ['Owned', 'Leased', 'Financed'];
export const RECREATIONAL_TYPES = ['Boat', 'Motorcycle', 'ATV', 'Golf Cart', 'RV/Motorhome', 'Jet Ski'];
export const STATES = ["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];
export const PREFIXES = ['Mr.', 'Mrs.', 'Ms.', 'Dr.', 'Prof.'];
export const SUFFIXES = ['Jr.', 'Sr.', 'II', 'III', 'IV', 'Esq.', 'MD', 'PhD'];
export const BASEMENT_TYPES = ['Unfinished', 'Partially Finished', 'Fully Finished'];
export const GENDERS = ['Male', 'Female', 'Non-binary', 'Prefer not to say'];

// Storage options for valuables — used in valuables follow-up questions
export const STORAGE_OPTIONS = [
  { v: 'home',       l: 'At home'        },
  { v: 'home_safe',  l: 'In a home safe' },
  { v: 'bank_vault', l: 'Bank vault'     },
  { v: 'mixed',      l: 'A mix'          },
];

// PURE vehicle type dropdown options — values must match PURE's UI text exactly
export const VEHICLE_TYPES = [
  'Private Passenger',
  'Antique Collectors Car',
  'Classic Collectors Car',
  'Exotic Collectors Car',
  'Motorcycles/Mopeds/Scooters',
  'Motor Home',
  'Recreational Trailer',
  'Collectors Trailer',
  'All Terrain Vehicles',
  'Snowmobiles',
  'Dune Buggies',
  'Golf Carts',
];